"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var DlgBonusTemplateCustomZoneEditor = /** @class */ (function (_super) {
    __extends(DlgBonusTemplateCustomZoneEditor, _super);
    function DlgBonusTemplateCustomZoneEditor(props) {
        return _super.call(this, props) || this;
    }
    DlgBonusTemplateCustomZoneEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                status_val: data.statusVal,
                statuses_avail: data.statusesAvail,
                zone_val: data.zoneVal,
                zones_avail: data.zonesAvail
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            status_val: 0,
            statuses_avail: [],
            zone_val: 0,
            zones_avail: []
        });
        this.doReSetRules();
    };
    DlgBonusTemplateCustomZoneEditor.prototype.doReSetRules = function () {
        this.setState({
            status_val_rules: { isError: false },
            zone_val_rules: { isError: false }
        });
    };
    DlgBonusTemplateCustomZoneEditor.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgBonusTemplateCustomZoneEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        var is_data_valid = true;
        if (this.state.status_val <= 0) {
            this.setState({
                status_val_rules: {
                    isError: true,
                    errorMessage: "Поле [Статус игрока] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.zone_val <= 0) {
            this.setState({
                zone_val_rules: {
                    isError: true,
                    errorMessage: "Поле [Игровая зона] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        return is_data_valid;
    };
    DlgBonusTemplateCustomZoneEditor.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.status_val, this.state.zone_val);
            }
        }
    };
    DlgBonusTemplateCustomZoneEditor.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgBonusTemplateCustomZoneEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 650 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Статус игрока:", placeholder: "Выберите статус игрока" }, value: { key: this.state.status_val, value: this.state.status_val.toString() }, onValueChanged: function (newVal) {
                        _this.setState({
                            status_val: newVal.key,
                            status_val_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetStatusVal(_this.state.status_val);
                        });
                    }, items: this.state.statuses_avail, required: true, rules: this.state.status_val_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игровая зона:", placeholder: "Выберите игровую зону" }, value: { key: this.state.zone_val, value: this.state.zone_val.toFixed(2) }, onValueChanged: function (newVal) {
                        _this.setState({
                            zone_val: newVal.key,
                            zone_val_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetZoneVal(_this.state.zone_val);
                        });
                    }, items: this.state.zones_avail, required: true, rules: this.state.zone_val_rules, floatKey: true }))));
    };
    return DlgBonusTemplateCustomZoneEditor;
}(React.Component));
exports.default = DlgBonusTemplateCustomZoneEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgBonusTemplateCustomZoneEditor.tsx
// module id = 2551
// module chunks = 0